/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{TooltipEditableField as t}from"../components/TooltipEditableField.js";import{tsx as o,tsxFragment as e}from"../../../../widgets/support/jsxFactory.js";function i(i){const l=i.fields.filter((t=>!0===t?.visible));return 0===l.length?null:o(e,null,l.map((e=>o(t,{context:i.context,field:e,key:e.id,mode:i.mode}))))}export{i as Fields};
